module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><circle id=\"icon-circle@2x-a\" cx=\"12\" cy=\"12\" r=\"4\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/circle.svg
// module id = 747
// module chunks = 0